import React from "react";

function Header({ title, subtitle }) {
  return (
    <div className="container">
      <div className="section-subtitle flex gap-3 items-center justify-center text-center font-semibold text-black dark:text-white">
        <p className="text-center w-[10px] h-[10px] bg-hl rounded-full text-black dark:text-white"></p>
        {title}
      </div>
      <p className="section-title text-center text-black dark:text-white">{subtitle}</p>
    </div>
  );
}

export default Header;
